module.exports = __webpack_public_path__ + "static2023-4-17/img/week_1.a54c62b9.png";